import {
    getConfigOptionText, getConfigOptionValue, reportTypeOptions, regimeOptions, runAllOptions, getSubRegimeOptions,
    isDataSourceReferencedInCurrentConfig
} from './DataSourceForm.Helpers';
import { reportType } from '../../../infrastructure/constants/reportType';
import appRoutes from '../../../infrastructure/constants/appRoutes';
import dataSourceKind from '../../../infrastructure/constants/dataSourceKind';
import FormGroup from '../../Common/FormGroup/FormGroup';
import guidance from './DataSourceForm.Guidance';
import IngestionConfigOption from '../../../types/ingestion/IngestionConfigOption';
import MultiSelectList from '../../Common/MultiSelectList/MultiSelectList';
import RadioButtonGroup from '../../Common/RadioButtonGroup/RadioButtonGroup';
import RefDataSource from '../../../types/report/RefDataSource';
import ReportConfig from '../../../types/report/ReportConfig';
import reportPageMode from '../Pages/ReportPage/ReportPageMode';
import SelectList from '../../Common/SelectList/SelectList';
import typeHelper from '../../../infrastructure/helpers/common/typeHelper';
import urlHelper from '../../../infrastructure/helpers/common/urlHelper';
import ReferencesModal from '../../Common/Modals/ReferencesModal/ReferencesModal';
import operandType from '../../../infrastructure/constants/functions/operandType';
import httpClient from '../../../infrastructure/helpers/common/httpClient';
import IngestionConfig from '../../../types/ingestion/IngestionConfig';
import IdAndName from '../../../types/report/IdAndName';
import React from 'react';
import ReportCollections from '../../../infrastructure/types/Functions/ReportCollections';
import copyArray from '../../../infrastructure/helpers/common/copyArray';
import { reportRegime, reportRegimesWithoutDeprecated } from '../../../infrastructure/constants/reportRegime';
import SwitchComponent from '../../Common/Switch/Switch';
import sortingHelper from '../../../infrastructure/helpers/common/sortingHelper';

interface Props {
    isWaiting: boolean;
    dataSources: IngestionConfigOption[],
    mode: string;
    reportConfig: ReportConfig;
    onChange: (reportConfig: ReportConfig, isGlobalDataSource?: boolean) => void;
    setSelectedCase?: (number: number, callback: () => void) => void;
    setSelectedAggregation?: (number: number, callback: () => void) => void;
    setSelectedDictionary?: (number: number, callback: () => void) => void;
    collections?: ReportCollections;
    hideReferences?: boolean;
    reportType?: string;
}

interface State {
    fields: IdAndName[];
    showReferencesModal: boolean;
    referenceOperandType: string;
    hideReferences?: boolean;
}
class DataSourceForm extends React.Component<Props, State> {
    constructor(props: any) {
        super(props);

        this.state = {
            fields: [],
            showReferencesModal: false,
            referenceOperandType: operandType.field
        }

        this.onNameChange = this.onNameChange.bind(this);
        this.onRegimeSelected = this.onRegimeSelected.bind(this);
        this.onSubRegimeSelected = this.onSubRegimeSelected.bind(this);
        this.onTypeSelected = this.onTypeSelected.bind(this);
        this.onRawConfigSelected = this.onRawConfigSelected.bind(this);
        this.onRefConfigSelected = this.onRefConfigSelected.bind(this);
        this.onRunStatusChange = this.onRunStatusChange.bind(this);
        this.onRefConfigRemoveClick = this.onRefConfigRemoveClick.bind(this);
        this.isChangeRegimeDisabled = this.isChangeRegimeDisabled.bind(this);
        this.isAddRefDataSourceDisabled = this.isAddRefDataSourceDisabled.bind(this);
        this.isRemoveRefDataSourceDisabled = this.isRemoveRefDataSourceDisabled.bind(this);
        this.getRawDataSourceContent = this.getRawDataSourceContent.bind(this);
        this.buildRefDataSourceItem = this.buildRefDataSourceItem.bind(this);
        this.buildDataSourceLink = this.buildDataSourceLink.bind(this);
        this.buildGlobalRefDataSources = this.buildGlobalRefDataSources.bind(this);
        this.getFields = this.getFields.bind(this);
        this.isGlobalModuleDataSource = this.isGlobalModuleDataSource.bind(this);
        this.isGlobalRefDataSource = this.isGlobalRefDataSource.bind(this);
        this.getGlobalRefDataSourcesValues = this.getGlobalRefDataSourcesValues.bind(this);
        this.getRegimeOptions = this.getRegimeOptions.bind(this);
    }

    onNameChange(e: React.ChangeEvent<HTMLInputElement>): void {

        let changes = { name: e.target.value } as ReportConfig;

        this.props.onChange(changes);
    }

    onRegimeSelected(value: string): void {

        let subRegime = getSubRegimeOptions(value)[0]?.value;

        let changes = { regime: value, subRegime: subRegime } as ReportConfig;

        this.props.onChange(changes);
    }

    onSubRegimeSelected(value: string): void {

        let changes = { subRegime: value } as ReportConfig;

        this.props.onChange(changes);
    }

    onTypeSelected(value: string): void {

        let changes = { type: value } as ReportConfig;

        if (value === reportType.directReporting) {

            changes.endpointFilters = [];
            changes.lookups = this.props.reportConfig.lookups.filter(x => !x.isEndpoint);
        }

        this.props.onChange(changes);
    }

    onRawConfigSelected(value: string): void {

        let rawDataSourceId = parseInt(value);

        let changes = { rawDataSourceId } as ReportConfig;

        this.props.onChange(changes);
    }

    onRefConfigSelected(value: string): void {

        let id = parseInt(value);

        if (!this.props.reportConfig.refDataSources.map(x => x.id).includes(id)) {

            let dataSources = this.props.collections?.dataSourceOptions || this.props.dataSources;

            let kind = dataSources?.find(x => x.id === id)?.dataSourceKind;

            let refDataSources = copyArray(this.props.reportConfig.refDataSources).concat([{ id, runStatus: 0, dataSouceKind: kind }]);

            let changes = { refDataSources } as ReportConfig;

            this.props.onChange(changes);
        }
    }

    onRunStatusChange(id: number, value: string): void {

        let target = this.props.reportConfig.refDataSources.find(x => x.id === id) as RefDataSource;

        target.runStatus = +value;

        let changes = { refDataSources: this.props.reportConfig.refDataSources } as ReportConfig;

        this.props.onChange(changes);
    }

    onRefConfigRemoveClick(value: string): void {

        let id = parseInt(value);

        let refDataSources = this.props.reportConfig.refDataSources.filter(x => x.id !== id);

        let changes = { refDataSources } as ReportConfig;

        this.props.onChange(changes);
    }

    isRawDataSource(config: IngestionConfigOption): boolean {
        return (
            config.dataSourceKind === dataSourceKind.raw ||
            config.dataSourceKind === dataSourceKind.rawAndRef
        );
    }

    isRefDataSource(config: IngestionConfigOption): boolean {
        return (
            config.dataSourceKind === dataSourceKind.ref ||
            config.dataSourceKind === dataSourceKind.rawAndRef
        );
    }

    isGlobalRefDataSource(config: IngestionConfigOption): boolean {
        return (config.dataSourceKind === dataSourceKind.globalRef);
    }

    isGlobalModuleDataSource(config: IngestionConfigOption): boolean {
        return config.isGlobalModuleDataSource as boolean;
    }

    isChangeRegimeDisabled(): boolean {

        return this.props.mode !== reportPageMode.create;
    }

    isAddRefDataSourceDisabled(): boolean {

        return this.props.mode === reportPageMode.readOnly;
    }

    isRemoveRefDataSourceDisabled(value: string): boolean {
        return (
            this.props.mode === reportPageMode.readOnly ||
            ((this.props.collections?.globalModuleConfig || false)
                && isDataSourceReferencedInCurrentConfig(parseInt(value), this.props.reportConfig, this.props.collections?.dataSources as IngestionConfig[]))
        );
    }

    async getFields(id: number, route: string) {

        let url = urlHelper.buildRoute([route, id]);

        let result = await httpClient.get<IngestionConfig>(url);

        let fields = result.data.fieldDefinitions as IdAndName[];

        this.setState({ fields, showReferencesModal: true });
    }

    getRawDataSourceContent(): JSX.Element {

        if (this.props.isWaiting) {

            return (<></>);
        }

        if (this.props.mode === reportPageMode.create) {

            return (
                <SelectList
                    options={this.props.dataSources.filter(this.isRawDataSource).map(x => { return { value: getConfigOptionValue(x), text: getConfigOptionText(x) } })}
                    className="form-control"
                    value={typeHelper.isNumber(this.props.reportConfig.rawDataSourceId) ? (this.props.reportConfig.rawDataSourceId as number).toString() : ''}
                    onChange={this.onRawConfigSelected}
                    includeEmptyOption={true} />
            );
        }

        let config = this.props.dataSources.find(x => x.id === this.props.reportConfig.rawDataSourceId) as IngestionConfigOption;

        if (!typeHelper.isObject(config)) {
            config = {} as IngestionConfigOption;
            config.id = this.props.reportConfig.rawDataSourceId as number;
            config.name = `Config id ${this.props.reportConfig.rawDataSourceId}`;
        }

        return (
            <div className='flex-container'>
                {this.buildDataSourceLink(config)}
                {!this.props.hideReferences &&
                    <div className="col-auto margin-0-important padding-right-0-important">
                        <button
                            onClick={() => this.getFields(config.id, 'ingestion')}
                            className="btn btn-light margin-0-important line-height-1 display-flex-important align-items-center "
                        >References
                        </button>
                    </div>
                }
            </div>
        );
    }

    buildGlobalRefDataSources(config: IngestionConfigOption): JSX.Element {
        return (
            <div style={{ padding: '2px 0' }}>
                <div className='flex-container  height-30px'>
                    {this.buildDataSourceLink(config)}
                    {!this.props.hideReferences &&
                        <div className="col-auto margin-0-important padding-right-0-important">
                            <button
                                onClick={() => this.getFields(config.id, 'global-ref-data-source')}
                                className="btn btn-light margin-0-important height-30px line-height-1 display-flex-important align-items-center"
                            >References
                            </button>
                        </div>
                    }
                </div>
            </div>
        );
    }

    onOptionalChange(id: number, value: boolean): void {

        let target = this.props.reportConfig.refDataSources.find(x => x.id === id) as RefDataSource;

        target.optional = value;

        let changes = { refDataSources: this.props.reportConfig.refDataSources } as ReportConfig;

        this.props.onChange(changes);
    }

    buildRefDataSourceItem(config: IngestionConfigOption): JSX.Element {

        let refDataSource = this.props.reportConfig.refDataSources.find(x => x.id === config.id) as RefDataSource;

        return (
            <div style={{ padding: '2px 0' }}>
                <div className="display-flex align-items-center justify-content-between">
                    <div >
                        {this.buildDataSourceLink(config)}
                    </div>
                    <div className="display-flex align-items-center justify-content-end">
                        <SwitchComponent
                            isHorizontal
                            label='Optional'
                            disableLabel='false'
                            enableLabel='true'
                            labelClasses='default-label'
                            checked={refDataSource.optional || false}
                            onChange={(value: boolean) => this.onOptionalChange(refDataSource.id, value)}
                        />
                        <div className="display-flex">
                            <div className='display-flex align-items-center'>
                                <RadioButtonGroup
                                    options={runAllOptions}
                                    value={refDataSource.runStatus.toString()}
                                    onChange={value => this.onRunStatusChange(refDataSource.id, value)}
                                    name={`run-all-${refDataSource.id}`} />
                            </div>
                            {!this.props.hideReferences &&
                                <div className="col-auto margin-0-important padding-right-0-important">
                                    <button
                                        onClick={() => this.getFields(config.id, 'ingestion')}
                                        className="btn btn-light margin-0-important height-30px line-height-1 display-flex-important align-items-center"
                                    >References
                                    </button>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    buildDataSourceLink(config: IngestionConfigOption): JSX.Element {

        let route = config.dataSourceKind === dataSourceKind.globalRef ?
            appRoutes.globalRefDataSource.preview :
            appRoutes.ingestion.edit;

        let url = urlHelper.buildUrl(route, { id: config.id });

        return (
            <a href={url} target="_blank" rel="noopener noreferrer" className="transparent-button">{config.name}</a>
        );
    }

    getRefDataSources(): IngestionConfigOption[] {

        let collection = [] as IngestionConfigOption[];

        if (this.props.reportType === reportType.globalModule) {

            let currentRefDataSourcesIds = this.props.reportConfig.refDataSources.map(x => x.id);

            let allDataSources = this.props.dataSources.filter(x => this.isRawDataSource(x) || this.isRefDataSource(x));

            collection = allDataSources.filter(x => currentRefDataSourcesIds.includes(x.id));

            let added = new Set<string>(collection.map(x => x.name));

            allDataSources.forEach((ds) => {
                if (!added.has(ds.name)) {
                    added.add(ds.name);
                    collection.push(ds)
                }
            });
        }
        else {
            collection = this.props.dataSources.filter(this.isRefDataSource);
        }

        sortingHelper.sortByNameAsc(collection);

        return collection;
    }

    getGlobalRefDataSourcesValues() {

        let globalRefDataSources = this.props.reportConfig.refDataSources.filter(x => x.dataSouceKind === dataSourceKind.globalRef)
            .map(x => x.id.toString());

        return globalRefDataSources;
    }

    getRegimeOptions() {
        if (this.props.mode === 'edit') {
            return regimeOptions(reportRegime);
        }
        else {
            return regimeOptions(reportRegimesWithoutDeprecated);
        }
    }

    render(): JSX.Element {
        const labelClass = 'col-3';
        const contentClass = 'col-9';

        const subRegimeOptions = getSubRegimeOptions(this.props.reportConfig.regime);

        return (
            <>
                <FormGroup label="Report name:" labelClassName={labelClass} contentClassName={contentClass} info={guidance.name}>
                    <input
                        type="text"
                        className="form-control"
                        value={this.props.reportConfig.name}
                        onChange={this.onNameChange}
                        disabled={this.props.mode === reportPageMode.readOnly} />
                </FormGroup>
                {
                    this.props.reportType !== reportType.globalModule &&
                    <>
                        <FormGroup label="Reporting regime:" labelClassName={labelClass} contentClassName={contentClass} info={guidance.regime}>
                            <SelectList
                                options={this.getRegimeOptions()}
                                className="form-control"
                                disabled={this.isChangeRegimeDisabled()}
                                value={this.props.reportConfig.regime}
                                onChange={this.onRegimeSelected}
                                includeEmptyOption={true} />
                            {
                                subRegimeOptions.length > 0 && this.props.reportConfig.subRegime &&
                                <div className="mt-2">
                                    <RadioButtonGroup
                                        options={subRegimeOptions}
                                        isDisabled={() => this.isChangeRegimeDisabled()}
                                        value={this.props.reportConfig.subRegime}
                                        onChange={this.onSubRegimeSelected}
                                        name={`sub-regime-options`} />
                                </div>
                            }
                        </FormGroup>
                        <FormGroup label="Reporting type:" labelClassName={labelClass} contentClassName={contentClass} info={guidance.reportType}>
                            <SelectList
                                options={reportTypeOptions}
                                className="form-control"
                                disabled={this.props.mode === reportPageMode.readOnly}
                                value={this.props.reportConfig.type}
                                onChange={this.onTypeSelected} />
                        </FormGroup>
                        <FormGroup label="Raw data source:" labelClassName={labelClass} contentClassName={contentClass} info={guidance.rawDataSource}>
                            {this.getRawDataSourceContent()}
                        </FormGroup>
                    </>
                }
                < FormGroup label="Client ref data sources:" labelClassName={labelClass} contentClassName={contentClass} info={guidance.refDataSources} >
                    <MultiSelectList
                        items={this.getRefDataSources()}
                        getItemValue={getConfigOptionValue}
                        getItemText={getConfigOptionText}
                        isItemDisabled={x => false}
                        className="form-control"
                        isSelectListDisabled={this.isAddRefDataSourceDisabled()}
                        isRemoveDisabled={this.isRemoveRefDataSourceDisabled}
                        values={this.props.reportConfig.refDataSources.map(x => x.id.toString())}
                        onSelectChange={this.onRefConfigSelected}
                        onRemoveClick={this.onRefConfigRemoveClick}
                        buildItem={this.buildRefDataSourceItem} />
                </FormGroup >
                <FormGroup label="CN global ref data sources:" labelClassName={labelClass} contentClassName={contentClass} info={guidance.globalRefDataSources}>
                    <MultiSelectList
                        items={this.props.dataSources.filter(this.isGlobalRefDataSource)}
                        getItemValue={getConfigOptionValue}
                        getItemText={getConfigOptionText}
                        isItemDisabled={x => false}
                        className="form-control"
                        isSelectListDisabled={this.isAddRefDataSourceDisabled()}
                        isRemoveDisabled={this.isRemoveRefDataSourceDisabled}
                        values={this.getGlobalRefDataSourcesValues()}
                        onSelectChange={this.onRefConfigSelected}
                        onRemoveClick={this.onRefConfigRemoveClick}
                        buildItem={this.buildGlobalRefDataSources} />
                </FormGroup>
                {
                    this.state.showReferencesModal &&
                    <ReferencesModal
                        reportConfig={this.props.reportConfig}
                        onClose={() => this.setState({ showReferencesModal: false })}
                        operandType={this.state.referenceOperandType}
                        fields={this.state.fields}
                        defaultSourceOptionTitle='References'
                        defaultFieldsOptionTitle='Select from List of Fields'
                        defaultResultOptionTitle='List of References'
                        sourcesTitle='Source Level:'
                        fieldsTitle='Field Level:'
                        modalTitle='References'
                        collections={this.props.collections as ReportCollections}
                    />
                }
            </>
        );
    }
}

export default DataSourceForm;
